module.exports = __webpack_public_path__ + "static/media/swegon_logo_color.6b75b530.svg";